import DashboardReportSelectedChart from './DashboardReportSelectedChartContainer';

export default DashboardReportSelectedChart;
